import { useContext, useEffect, useState } from 'react';
import { shopSettingsApi } from '../services/api';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Resolves the default "Email to me" (self-relay) address: the shop's configured
 * relay_email when set, otherwise the signed-in owner's account email. The value
 * is only a default — callers let the owner override it per-send.
 */
export function useRelayEmail(): { defaultEmail: string; loading: boolean } {
  // Read the context directly (not useAuth) so this leaf hook degrades gracefully
  // to the setting-only default when rendered outside an AuthProvider.
  const user = useContext(AuthContext)?.user ?? null;
  const [settingEmail, setSettingEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    shopSettingsApi
      .get()
      .then((res) => {
        if (live) setSettingEmail(res.data?.relay_email ?? null);
      })
      .catch(() => {
        if (live) setSettingEmail(null);
      })
      .finally(() => {
        if (live) setLoading(false);
      });
    return () => {
      live = false;
    };
  }, []);

  const defaultEmail = (settingEmail && settingEmail.trim()) || user?.email || '';
  return { defaultEmail, loading };
}
